import { UrlMatchResult, UrlSegment } from "@angular/router";
import { TranslatableRoute } from "./core/interfaces/translatable-route";
import { GenericResolver } from "./shared/generic/services/generic.resolver";
import { ContactFromResolver } from "./sites/main/features/contact/services/contact-form.resolver";
import { ProductsResolver } from "./sites/main/features/products/services/products.resolver";
import { RecipeFacetResolver } from "./sites/main/features/recipes/resolvers/recipe-facet.resolver";
import { RecipeResolver } from "./sites/main/features/recipes/resolvers/recipe.resolver";
import { PAGE_TYPE } from "./sites/main/features/search/enums/page-type.enum";
import { SearchFacetsResolver } from "./sites/main/features/search/services/search-facets.resolver";
import { SearchTermResolver } from "./sites/main/features/search/services/search-term.resolver";
import { SearchTypeResolver } from "./sites/main/features/search/services/search-type.resolver";
import { RoutePrefixRegistry } from "./sites/route-prefix-registry.service";

export const routes: TranslatableRoute[] = [
  // {
  //   path: "magazine",
  //   translateKey: "ROUTES.magazine",
  //   loadComponent: () =>
      // import("./sites/magazine/magazine.app.component").then(
      //   (m) => m.MagazinAppComponent,
      // ),
  //   children: [
  //     {
  //       path: "news",
  //       translateKey: "ROUTES.news",
  //       data: { breadCrumbLabel: "BREAD.news" },
  //       loadComponent: () =>
          // import("./sites/magazine/features/home/home.component").then(
          //   (m) => m.HomeComponent,
          // ),
  //     },
  //     {
  //       path: "news/:alias/:id/:duplicate",
  //       translateKey: "ROUTES.news",
  //       data: { breadCrumbLabel: "BREAD.news" },
  //       loadComponent: () =>
          // import("./sites/magazine/features/home/home.component").then(
          //   (m) => m.HomeComponent,
          // ),
  //     },
  //     {
  //       path: "cook",
  //       translateKey: "ROUTES.cook",
  //       data: { breadCrumbLabel: "BREAD.cook" },
  //       loadComponent: () =>
          // import("./sites/magazine/features/cook/cook.component").then(
          //   (m) => m.CookComponent,
          // ),
  //     },
  //     {
  //       path: "cultivate",
  //       translateKey: "ROUTES.cultivate",
  //       loadComponent: () =>
          // import("./sites/magazine/features/rubric/rubric.component").then(
          //   (m) => m.RubricComponent,
          // ),
  //       data: { rubric: "cultivate", breadCrumbLabel: "BREAD.cultivate" },
  //     },
  //     {
  //       path: "explore",
  //       translateKey: "ROUTES.explore",
  //       loadComponent: () =>
          // import("./sites/magazine/features/rubric/rubric.component").then(
          //   (m) => m.RubricComponent,
          // ),
  //       data: { rubric: "explore", breadCrumbLabel: "BREAD.explore" },
  //     },
  //     {
  //       path: "article/:alias/:id/:duplicate",
  //       translateKey: "ROUTES.article",
  //       params: ["alias", "id", "duplicate"],
  //       loadComponent: () =>
          // import("./sites/magazine/features/article/article.component").then(
          //   (m) => m.ArticleComponent,
          // ),
  //     },
  //     {
  //       path: "recipes/:alias/:id",
  //       translateKey: "ROUTES.recipes",
  //       params: ["alias", "id"],
  //       data: { isLegumiz: true },
  //       resolve: { recipe: RecipeResolver },
  //       loadComponent: () =>
          // import("./sites/main/features/recipes/components/recipe/recipe.component").then(
          //   (m) => m.RecipeComponent,
          // ),
  //     },
  //     {
  //       path: "not-found",
  //       loadComponent: () =>
          // import("./shared/not-found/components/not-found.component").then(
          //   (m) => m.NotFoundComponent,
          // ),
  //       translateKey: "ROUTES.not-found",
  //     },
  //     {
  //       path: ":url",
  //       loadComponent: () =>
          // import("./shared/generic/components/generic.component").then(
          //   (m) => m.GenericComponent,
          // ),
  //     },
  //   ],
  // },
  {
    path: "",
    loadComponent: () =>
      import("./sites/main/main.app.component").then((m) => m.MainAppComponent),
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./sites/main/features/home/home.component").then(
            (m) => m.HomeComponent,
          ),
      },
      {
        path: "vegetables/product-news",
        data: { breadCrumbLabel: "BREAD.vegetables" },
        loadComponent: () =>
          import("./sites/main/features/products/components/news/news.component").then(
            (m) => m.NewsComponent,
          ),
        translateKey: "ROUTES.vegetables/ROUTES.product-news",
      },
      {
        path: "vegetables/:theme",
        data: { breadCrumbLabel: "BREAD.vegetables" },
        loadComponent: () =>
          import("./sites/main/features/products/products.component").then(
            (m) => m.ProductsComponent,
          ),
        translateKey: "ROUTES.vegetables",
        resolve: {
          productListArgs: ProductsResolver,
        },
        params: ["theme"],
      },
      {
        path: "vegetables/p/:alias/:id",
        translateKey: "ROUTES.vegetables/ROUTES.p",
        loadComponent: () =>
          import("./sites/main/features/products/components/product/product.component").then(
            (m) => m.ProductComponent,
          ),
        params: ["alias", "id"],
      },
      {
        matcher: filtersMatcherProducts,
        loadComponent: () =>
          import("./sites/main/features/products/products.component").then(
            (m) => m.ProductsComponent,
          ),
        data: { breadCrumbLabel: "BREAD.vegetables" },
        resolve: { productListArgs: ProductsResolver },
      },
      {
        path: "since-1853",
        data: { breadCrumbLabel: "BREAD.since-1853" },
        loadComponent: () =>
          import("./sites/main/features/corporate/corporate.component").then(
            (m) => m.CorporateComponent,
          ),
        translateKey: "ROUTES.since-1853",
      },
      {
        path: "since-1853/news",
        translateKey: "ROUTES.since-1853/ROUTES.news",
        data: { breadCrumbLabel: "BREAD.news" },
        loadComponent: () =>
          import("./sites/main/features/corporate/corporate.component").then(
            (m) => m.CorporateComponent,
          ),
      },
      {
        path: "since-1853/company-story",
        translateKey: "ROUTES.since-1853/ROUTES.company-story",
        loadComponent: () =>
          import("./sites/main/features/corporate/corporate.component").then(
            (m) => m.CorporateComponent,
          ),
        data: {
          rubric: "company-story",
          breadCrumbLabel: "BREAD.company-story",
        },
      },
      {
        path: "since-1853/csr-commitments",
        translateKey: "ROUTES.since-1853/ROUTES.csr-commitments",
        loadComponent: () =>
          import("./sites/main/features/corporate/corporate.component").then(
            (m) => m.CorporateComponent,
          ),
        data: {
          rubric: "csr-commitments",
          breadCrumbLabel: "BREAD.csr-commitments",
        },
      },
      {
        path: "since-1853/vegetal-innovations",
        translateKey: "ROUTES.since-1853/ROUTES.vegetal-innovations",
        loadComponent: () =>
          import("./sites/main/features/corporate/corporate.component").then(
            (m) => m.CorporateComponent,
          ),
        data: {
          rubric: "vegetal-innovations",
          breadCrumbLabel: "BREAD.vegetal-innovations",
        },
      },
      {
        path: "since-1853/vegetal-innovations",
        translateKey: "ROUTES.since-1853/ROUTES.vegetal-innovations",
        loadComponent: () =>
          import("./sites/main/features/corporate/corporate.component").then(
            (m) => m.CorporateComponent,
          ),
        data: {
          rubric: "vegetal-innovations",
          breadCrumbLabel: "BREAD.vegetal-innovations",
        },
      },
      {
        path: "since-1853/article/:alias/:id/:duplicate",
        translateKey: "ROUTES.since-1853/ROUTES.article",
        params: ["alias", "id", "duplicate"],
        loadComponent: () =>
          import("./sites/main/features/corporate/components/article/article.component").then(
            (m) => m.CorporateArticleComponent,
          ),
      },
      {
        path: "since-1853/field-plate",
        translateKey: "ROUTES.since-1853/ROUTES.field-plate",
        data: { breadCrumbLabel: "BREAD.field-plate" },
        loadComponent: () =>
          import("./sites/main/features/corporate/components/field-plate/field-plate.component").then(
            (m) => m.CorporateFieldPlateComponent,
          ),
      },
      {
        path: "since-1853/field-plate/:alias/:id/:duplicate",
        translateKey: "ROUTES.since-1853/ROUTES.field-plate",
        params: ["alias", "id", "duplicate"],
        data: { breadCrumbLabel: "BREAD.field-plate" },
        loadComponent: () =>
          import("./sites/main/features/corporate/components/vegetable/components/vegetable.component").then(
            (m) => m.CorporateVegetableComponent,
          ),
      },
      {
        path: "menu-page",
        data: { breadCrumbLabel: "BREAD.menu-page" },
        loadComponent: () =>
          import("./sites/main/features/menu-page/menu-page.component").then(
            (m) => m.MenuPageComponent,
          ),
        translateKey: "ROUTES.menu-page",
      },
      {
        path: "menu-page/menu-one",
        data: { breadCrumbLabel: "BREAD.menu-page", rubric: "menu-one" },
        loadComponent: () =>
          import("./sites/main/features/menu-page/menu-page.component").then(
            (m) => m.MenuPageComponent,
          ),
        translateKey: "ROUTES.menu-page/ROUTES.menu-one",
      },
      {
        path: "menu-page/menu-two",
        data: { breadCrumbLabel: "BREAD.menu-page", rubric: "menu-two" },
        loadComponent: () =>
          import("./sites/main/features/menu-page/menu-page.component").then(
            (m) => m.MenuPageComponent,
          ),
        translateKey: "ROUTES.menu-page/ROUTES.menu-two",
      },
      {
        path: "menu-page/menu-three",
        data: { breadCrumbLabel: "BREAD.menu-page", rubric: "menu-three" },
        loadComponent: () =>
          import("./sites/main/features/menu-page/menu-page.component").then(
            (m) => m.MenuPageComponent,
          ),
        translateKey: "ROUTES.menu-page/ROUTES.menu-three",
      },
      {
        path: "menu-page/menu-four",
        data: { breadCrumbLabel: "BREAD.menu-page", rubric: "menu-four" },
        loadComponent: () =>
          import("./sites/main/features/menu-page/menu-page.component").then(
            (m) => m.MenuPageComponent,
          ),
        translateKey: "ROUTES.menu-page/ROUTES.menu-four",
      },
      {
        path: "menu-page/article/:alias/:id/:duplicate",
        translateKey: "ROUTES.menu-page/ROUTES.article",
        params: ["alias", "id", "duplicate"],
        loadComponent: () =>
          import("./sites/main/features/menu-page/components/article/article.component").then(
            (m) => m.MenuPageArticleComponent,
          ),
      },

      {
        path: "recipes-home",
        data: { breadCrumbLabel: "BREAD.recipes-home" },
        loadComponent: () =>
          import("./sites/main/features/recipe-home/recipe-home.component").then(
            (m) => m.RecipeHomeComponent,
          ),
        translateKey: "ROUTES.recipes-home",
        resolve: {
          recipeListArg: RecipeFacetResolver,
        },
      },
      {
        path: "recipes/:theme",
        data: { breadCrumbLabel: "BREAD.recipes" },
        loadComponent: () =>
          import("./sites/main/features/recipes/recipes.component").then(
            (m) => m.RecipeListContainerComponent,
          ),
        translateKey: "ROUTES.recipes",
        resolve: {
          recipeListArg: RecipeFacetResolver,
        },
        params: ["theme"],
      },
      {
        path: "recipes/r/:alias/:id",
        translateKey: "ROUTES.recipes/ROUTES.r",
        loadComponent: () =>
          import("./sites/main/features/recipes/components/recipe/recipe.component").then(
            (m) => m.RecipeComponent,
          ),
        resolve: { recipe: RecipeResolver },
        params: ["alias", "id"],
      },
      {
        matcher: filtersMatcherRecipes,
        loadComponent: () =>
          import("./sites/main/features/recipes/recipes.component").then(
            (m) => m.RecipeListContainerComponent,
          ),
        data: { breadCrumbLabel: "BREAD.recipes" },
        resolve: { recipeListArg: RecipeFacetResolver },
      },
      {
        path: "faq",
        data: { breadCrumbLabel: "BREAD.faq" },
        loadComponent: () =>
          import("./sites/main/features/faq/faq.component").then(
            (m) => m.FaqListComponent,
          ),
        translateKey: "ROUTES.faq",
      },
      {
        path: "faq/:rubric",
        data: { breadCrumbLabel: "BREAD.faq" },
        loadComponent: () =>
          import("./sites/main/features/faq/faq.component").then(
            (m) => m.FaqListComponent,
          ),
        translateKey: "ROUTES.faq",
        params: ["rubric"],
      },
      {
        path: "faq/:rubric/:alias/:id",
        data: { breadCrumbLabel: "BREAD.faq" },
        loadComponent: () =>
          import("./sites/main/features/faq/components/article/faq-article.component").then(
            (m) => m.FaqArticleComponent,
          ),
        translateKey: "ROUTES.faq",
        params: ["rubric", "alias", "id"],
      },
      {
        path: "search/:searchTerm",
        loadComponent: () =>
          import("./sites/main/features/search/search.component").then(
            (m) => m.SearchComponent,
          ),
        translateKey: "ROUTES.search",
        params: ["searchTerm"],
        resolve: {
          term: SearchTermResolver,
        },
        children: [
          {
            path: "all",
            pathMatch: "prefix",
            resolve: {
              type: SearchTypeResolver,
            },
            translateKey: "ROUTES.all",
            children: [
              {
                path: "**",
                loadComponent: () =>
                  import("./sites/main/features/search/components/search-all/search-all.component").then(
                    (m) => m.SearchAllComponent,
                  ),
                resolve: {
                  facets: SearchFacetsResolver,
                },
              },
            ],
          },
          {
            path: "recipes-home",
            pathMatch: "prefix",
            translateKey: "ROUTES.recipes-home",
            data: { type: PAGE_TYPE.RECIPES },
            resolve: {
              type: SearchTypeResolver,
            },
            children: [
              {
                path: "**",
                loadComponent: () =>
                  import("./sites/main/features/search/components/search-recipes/search-recipes.component").then(
                    (m) => m.SearchRecipesComponent,
                  ),
                resolve: {
                  facets: SearchFacetsResolver,
                },
              },
            ],
          },
          {
            path: "products-search",
            pathMatch: "prefix",
            translateKey: "ROUTES.products-search",
            data: { type: PAGE_TYPE.PRODUCTS },
            resolve: {
              type: SearchTypeResolver,
            },
            children: [
              {
                path: "**",
                loadComponent: () =>
                  import("./sites/main/features/search/components/search-products/search-products.component").then(
                    (m) => m.SearchProductsComponent,
                  ),
                resolve: {
                  facets: SearchFacetsResolver,
                },
              },
            ],
          },
          {
            path: "articles-search",
            translateKey: "ROUTES.articles-search",
            pathMatch: "prefix",
            data: { type: PAGE_TYPE.ARTICLES },
            resolve: {
              type: SearchTypeResolver,
            },
            children: [
              {
                path: "**",
                loadComponent: () =>
                  import("./sites/main/features/search/components/search-articles/search-articles.component").then(
                    (m) => m.SearchArticlesComponent,
                  ),
                resolve: {
                  facets: SearchFacetsResolver,
                },
              },
            ],
          },
          {
            path: "",
            redirectTo: "all",
            pathMatch: "full",
          },
        ],
      },
      {
        path: "contact",
        data: { breadCrumbLabel: "BREAD.contact" },
        loadComponent: () =>
          import("./sites/main/features/contact/contact.component").then(
            (m) => m.ContactComponent,
          ),
        translateKey: "ROUTES.contact",
        children: [
          {
            path: ":form",
            loadComponent: () =>
              import("./sites/main/features/contact/components/contact-form/contact-form.component").then(
                (m) => m.ContactFormComponent,
              ),
            resolve: { section: ContactFromResolver },
          },
        ],
      },
      {
        path: "sitemap",
        loadComponent: () =>
          import("./sites/main/features/sitemap/sitemap.component").then(
            (m) => m.SitemapComponent,
          ),
        translateKey: "ROUTES.sitemap",
      },
      {
        path: "not-found",
        loadComponent: () =>
          import("./shared/not-found/components/not-found.component").then(
            (m) => m.NotFoundComponent,
          ),
        translateKey: "ROUTES.not-found",
      },

      {
        path: ":url",
        loadComponent: () =>
          import("./shared/generic/components/generic.component").then(
            (m) => m.GenericComponent,
          ),
        resolve: { page: GenericResolver },
      },
    ],
  },
  { path: "**", redirectTo: "not-found" },
];

function filtersMatcherProducts(segments: UrlSegment[]): UrlMatchResult | null {
  const first = segments[0]?.path;
  const validPrefix = RoutePrefixRegistry.getTranslated("ROUTES.vegetables");

  if (first !== validPrefix) return null;

  return {
    consumed: segments,
    posParams: {
      category: segments[0],
      filters: new UrlSegment(
        segments
          .slice(1)
          .map((s) => s.path)
          .join("/"),
        {},
      ),
    },
  };
}

function filtersMatcherRecipes(segments: UrlSegment[]): UrlMatchResult | null {
  const first = segments[0]?.path;
  const validPrefix = RoutePrefixRegistry.getTranslated("ROUTES.recipes");

  if (first !== validPrefix) return null;

  return {
    consumed: segments,
    posParams: {
      category: segments[0],
      filters: new UrlSegment(
        segments
          .slice(1)
          .map((s) => s.path)
          .join("/"),
        {},
      ),
    },
  };
}

